import { useEffect } from 'react';

const FreeTrial = () => {
  useEffect(() => {
    window.location.href = 'https://app.knine.ai/register';
  }, []);

  return null;
};

export default FreeTrial;
